var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusCircle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "plus",
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add-svgrepo-com",
    transform: "translate(0.246 -0.282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21711",
    "data-name": "Group 21711"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    transform: "translate(-0.246 0.282)",
    fill: "#fff",
    stroke: "#156ae6",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 24.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21740",
    "data-name": "Group 21740",
    transform: "translate(0.277 0.789)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14765",
    "data-name": "Path 14765",
    d: "M160.337,147.435H141.173a1.268,1.268,0,1,0,0,2.535h19.164a1.268,1.268,0,1,0,0-2.535Z",
    transform: "translate(-125.424 -123.356)",
    fill: "#156ae6",
    stroke: "#156ae6",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14766",
    "data-name": "Path 14766",
    d: "M20.437,0H1.273a1.268,1.268,0,1,0,0,2.535H20.437a1.268,1.268,0,1,0,0-2.535Z",
    transform: "translate(26.598 14.493) rotate(90)",
    fill: "#156ae6",
    stroke: "#156ae6",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircle);
export default __webpack_public_path__ + "static/media/plus-circle.12b60d95f9ccf520078f94d88742f7e4.svg";
export { ForwardRef as ReactComponent };